// extracted by mini-css-extract-plugin
module.exports = {"message":"_base-input-text_message_1k4mU","content":"_base-input-text_content_3-Dth","send":"_base-input-text_send_28V2T","receive":"_base-input-text_receive_2gPzc"};